import { useSelector } from "react-redux";
import {
	getChargeBeeFeatureFlagEnabled,
	getError,
	getResult,
	getResultIsLoading,
	getResultsPage,
	getResultsPerPage,
	getResultsSortColumn,
	getResultsSortDirection,
	getResultsTotal,
	getSearchParams,
} from "./selectors";
import _ from "lodash";

export default function useSearchState() {
	const data = useSelector(getResult);
	const params = useSelector(getSearchParams);
	const paramsExist = !_.isEmpty(params);
	const loading = useSelector(getResultIsLoading);
	const error = useSelector(getError);
	const chargeBeeFeatureFlagEnabled = useSelector(
		getChargeBeeFeatureFlagEnabled,
	);
	const resultsPage = useSelector(getResultsPage);
	const resultsPerPage = useSelector(getResultsPerPage);
	const resultsTotal = useSelector(getResultsTotal);
	const resultsSortColumn = useSelector(getResultsSortColumn);
	const resultsSortDirection = useSelector(getResultsSortDirection);

	return {
		chargeBeeFeatureFlagEnabled,
		error,
		data,
		loading,
		params,
		paramsExist,
		resultsPage,
		resultsPerPage,
		resultsSortColumn,
		resultsSortDirection,
		resultsTotal,
	};
}
